import { createStylesParams } from '@wix/tpa-settings';

import {
  backgroundAndBordersStylesParams,
  BackgroundAndBordersStylesParams,
} from './BackgroundAndBorders/stylesParams';
import {
  fulfillmentPickerStylesParams,
  FulfillmentPickerStylesParams,
} from './FulfillmentPicker/stylesParams';
import { imageStylesParams, ImageStylesParams } from './Image/stylesParams';
import {
  locationButtonStylesParams,
  LocationButtonStylesParams,
} from './LocationButton/stylesParams';
import { textStylesParams, TextStylesParams } from './Text/stylesParams';
import {
  viewCartStylesParams,
  ViewCartStylesParams,
} from './OrderButton/stylesParams';
import {
  navigationStylesParams,
  NavigationStylesParams,
} from './Navigation/stylesParams';

export type DesignStylesParams = TextStylesParams &
  ImageStylesParams &
  BackgroundAndBordersStylesParams &
  FulfillmentPickerStylesParams &
  NavigationStylesParams &
  LocationButtonStylesParams &
  ViewCartStylesParams;

export const designStylesParams = createStylesParams<DesignStylesParams>({
  ...textStylesParams,
  ...imageStylesParams,
  ...backgroundAndBordersStylesParams,
  ...fulfillmentPickerStylesParams,
  ...locationButtonStylesParams,
  ...viewCartStylesParams,
  ...navigationStylesParams,
});
